import preloadSw from "./setup";
import {getSwRegistration} from "./sw_registration";

// let _redux_store;
// let _online;

function noop() {}

const offline_button_style = {opacity: 0.3};


export function wrapAction(cb) {
  return navigator.onLine ? cb : noop;
}

export function wrapStyle(s) {
  return navigator.onLine ? s : {...s, opacity: 0.3};
}

export function opacityView() {
}


/*
// does not work
// listen for online change
export function setupSwHelper(store) {
  _redux_store = store;

  return store.subscribe(() => {
    const state = store.getState()

    _online = state.sw_reducer.online

    if (state.justSignedIn) {
      console.log("JUST SIGNED IN: preloading!");
      preloadSw();
    }
  })
}
*/

// API w/ sw

function enabled() {
  return 'serviceWorker' in navigator;
}

// https://web.dev/two-way-communication-guide/
export function send(sw, type, payload, timeout = 3000) {
  const data = {type, payload};

  return new Promise((res, rej) => {
    const channel = new MessageChannel();

    const timeout_fn = () => rej("timeout");
    let timer;
    if (timeout) {
        timer = setTimeout(timeout_fn, timeout);
    }

    channel.port1.onmessage = (e) => {
      timer && clearTimeout(timer);
      res(e.data);
    }

    sw.postMessage(data, [channel.port2]);
  })
}

export function sendToCurrent() {
  const args = Array.from(arguments);
  const to = navigator.serviceWorker.controller;

  if (to) {
    return send.apply(null, [to].concat(args));
  } else {
    return Promise.reject()
  }
}

export function sendToActive() {
  const args = Array.from(arguments);
  const registration = getSwRegistration();
  const to = registration && registration.active;

  if (to) {
    return send.apply(null, [to].concat(args));
  } else {
    return Promise.reject()
  }
}

export function sendToWaiting() {
  const args = Array.from(arguments);
  const registration = getSwRegistration();
  const to = registration && registration.waiting;

  if (to) {
    return send.apply(null, [to].concat(args));
  } else {
    return Promise.reject()
  }
}

// specific to waiting SW
const skipWaiting = () => sendToWaiting("skip_waiting");

// specific to active SW
const clientsClaim = (timeout = 1000) => sendToActive("clients_claim", null, timeout);

// specific to current SW
const getVersion = (timeout = 1000) => sendToCurrent("get_version", null, timeout);
const storageUsage = (timeout = 1000) => sendToCurrent("storage_usage", null, timeout);

const cacheUrls = (cache_name, urls, timeout = 3000) => {
  return sendToCurrent("cache_urls", {urls, cache_name}, timeout)
}
const deleteUrls = (cache_name, urls, timeout = 3000) => {
  return sendToCurrent("delete_urls", {urls, cache_name}, timeout)
}

const deleteCache = (cache_name) => sendToCurrent("delete_cache", {cache_name});
const deletePrecache = () => sendToCurrent("delete_precache");
const deleteAllCache = (delete_precache = false) => {
  return sendToCurrent("delete_all_cache", { delete_precache });
}

// const clearCache = (cache_name) => sendToCurrent("clear_cache", {cache_name});
// const clearAllCache = () => sendToCurrent("clear_all_cache");

const getPrecacheName = () => sendToCurrent("get_precache_name");


export const sw_api = {
  send,
  getVersion, skipWaiting, clientsClaim, storageUsage,
  cacheUrls, deleteUrls,
  deleteCache, deleteAllCache,
  deletePrecache,
  getPrecacheName,
  // clearCache, clearAllCache
}

window.sw_api = sw_api;

